<template>
    <v-container fluid class="container-infos d-flex flex-column justify-center align-center cyan lighten-5">
        <v-row class='d-flex flex-row justify-space-around'>

            <v-col cols='3' class='d-flex flex-column' v-if="!isMobile">

                <v-col >
                    <div class=" text-color-number d-flex flex-column justify-bottom align-center users-total-display">{{usersTotal}}</div>
                </v-col>
                <v-col class='my-n11'>
                    <div class=" text-uppercase font-weight-bold text-color-title d-flex flex-column justify-center align-center">{{$t('users')}}</div>
                </v-col>
                <v-col >
                    <div class="text-color-text font-weight-bold text-center d-flex flex-column justify-center align-center" v-html="$t('dash_overview.info_user_text')"></div>
                </v-col>

            </v-col>

            <v-col cols='3' class='d-flex flex-column justify-center align-center' v-else>

                <div class="">{{usersTotal | kFormatter}}</div>
                <v-icon class='mt-2' large>mdi-account</v-icon>

            </v-col>

            <v-col cols='3' class='d-flex flex-column ' v-if="!isMobile">

                <v-col >
                    <div class="text-color-number d-flex flex-column justify-center align-center impressions-total-display">{{impressions}}</div>
                </v-col>
                <v-col class='my-n11' >
                    <div class=" text-uppercase font-weight-bold text-color-title d-flex flex-column justify-center align-center">{{$t('dash_overview.visualizations')}}</div>
                </v-col>
                <v-col >
                    <div class="text-color-text font-weight-bold text-center d-flex flex-column justify-center align-center">{{$t('dash_overview.info_visualization_text')}}</div>
                </v-col>

            </v-col>

            <v-col cols='3' class='d-flex flex-column justify-center align-center' v-else>

                <div class="">{{impressions | kFormatter}}</div>
                <v-icon class='mt-2' large>mdi-eye-check-outline</v-icon>

            </v-col>

            <v-col cols='3' class='d-flex flex-column justify-center align-center' v-if="!isMobile">

                <v-col >
                    <div class="text-color-number d-flex flex-column justify-center align-center cities-total-display">{{cities}}</div>
                </v-col>
                <v-col class='my-n11' >
                    <div class=" text-uppercase font-weight-bold text-color-title d-flex flex-column justify-center align-center">{{$t('dash_overview.cities')}}</div>
                </v-col>
                <v-col >
                    <div class="text-color-text font-weight-bold text-center ">{{$t('dash_overview.info_cities_text')}}</div>
                </v-col>

            </v-col>

            <v-col cols='3' class='d-flex flex-column justify-center align-center' v-else>

                <div class="">{{cities | kFormatter}}</div>
                <v-icon class='mt-2' large>mdi-city</v-icon>

            </v-col>

        </v-row>
    </v-container>
</template>

<script>

export default {

    name: 'InfosContainer',

    props: ['impressions', 'cities', 'usersTotal'],
    
    filters: {

        kFormatter(num) {
            return Math.abs(num) > 999 ? Math.sign(num) * ((Math.abs(num) / 1000).toFixed(1)) + 'k' : Math.sign(num) * Math.abs(num)
        }

    }

}

</script>

<style scoped>

.container-infos {

    height: 20vh
}

.text-color-number {

    color: #288a8a;
    font-size: 35px;

}

.text-color-title {

    color: #288a8a;
    font-size: 25px;

}

.text-color-text {

    color: grey;
    font-size: 15px;

}

</style>